// i18n translations for Signapharma (FR / DE / EN / IT)

export const LANGUAGES = [
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "en", label: "English" },
  { code: "it", label: "Italiano" },
];

export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      products: "Produits",
      gallery: "Galerie",
      faq: "FAQ & Livraison",
      contact: "Contact",
      cart: "Panier",
      quote: "Demander un devis",
    },
    hero: {
      eyebrow: "Genève · Suisse",
      title_line1: "Enseignes lumineuses",
      title_line2: "pour pharmacies",
      subtitle:
        "Signapharma, spécialiste et fournisseur d'enseignes lumineuses pour pharmacies. Société genevoise, expédition dans toute la Suisse.",
      cta_primary: "Découvrir nos produits",
      cta_secondary: "Nous contacter",
    },
    categories_section: {
      label: "Catalogue",
      title: "Deux univers, une exigence",
      subtitle:
        "Des croix de pharmacie à haute visibilité aux enseignes lettrées sur-mesure, nous illuminons votre officine.",
    },
    cat: {
      croix: {
        name: "Croix de pharmacie",
        desc: "Croix lumineuses classiques, point à point et néon LED.",
      },
      enseigne: {
        name: "Enseignes de pharmacie",
        desc: "Lettres boîtier, rétro-éclairées, inox et néon intérieur.",
      },
    },
    home_features: {
      title: "La signature lumineuse suisse",
      f1_title: "Fabrication sur-mesure",
      f1_desc: "Chaque projet est étudié, dessiné et fabriqué selon vos besoins.",
      f2_title: "Livraison Suisse",
      f2_desc: "Expédition soignée dans toute la Suisse depuis Genève.",
      f3_title: "Garantie & SAV",
      f3_desc: "Composants LED de qualité professionnelle, garantis.",
    },
    products: {
      title: "Nos produits",
      subtitle: "Parcourez les deux gammes Signapharma.",
      view: "Voir le produit",
      from: "Sur devis",
      filter: "Filtrer",
      all: "Tous",
      subcategories: "Sous-catégories",
    },
    pdp: {
      configure: "Configurez votre enseigne",
      dimensions: "Dimensions",
      finish: "Finition",
      lighting: "Éclairage",
      color: "Couleur",
      add_to_cart: "Ajouter au panier",
      ask_quote: "Demander un devis",
      description: "Description",
      features: "Caractéristiques",
      delivery: "Fabrication & livraison 3 à 5 semaines · Suisse",
      related: "Produits similaires",
      your_text: "Votre texte",
      font: "Police",
      backing: "Support / fond",
      preview_label: "Aperçu temps réel",
    },
    cart: {
      title: "Votre panier",
      empty: "Votre panier est vide.",
      continue: "Continuer mes achats",
      checkout: "Passer la commande",
      item: "Article",
      qty: "Qté",
      remove: "Retirer",
      summary: "Récapitulatif",
      note: "Les prix finaux vous seront communiqués après étude de votre configuration.",
      total_items: "Articles au total",
    },
    checkout: {
      title: "Finaliser ma demande",
      subtitle:
        "Transmettez-nous vos coordonnées — nous reviendrons vers vous sous 24h avec un devis personnalisé.",
      name: "Nom et prénom",
      email: "E-mail",
      phone: "Téléphone",
      company: "Pharmacie / Société",
      address: "Adresse",
      city: "Ville",
      postal_code: "Code postal",
      country: "Pays",
      notes: "Notes / précisions",
      submit: "Envoyer la demande",
      success: "Demande envoyée — nous vous recontactons rapidement.",
      error: "Une erreur est survenue, merci de réessayer.",
    },
    gallery: {
      title: "Galerie de réalisations",
      subtitle: "Quelques enseignes Signapharma installées en Suisse.",
    },
    faq: {
      title: "FAQ & Livraison",
      subtitle: "Tout ce que vous devez savoir pour commander votre enseigne.",
      items: [
        {
          q: "Livrez-vous dans toute la Suisse ?",
          a: "Oui. Nous expédions depuis Genève vers tous les cantons suisses. Des frais de livraison peuvent s'appliquer selon le volume et la destination.",
        },
        {
          q: "Quels sont les délais de fabrication ?",
          a: "Les enseignes sur-mesure sont fabriquées en 3 à 5 semaines selon la complexité du projet et les finitions choisies.",
        },
        {
          q: "Proposez-vous la pose et l'installation ?",
          a: "Oui, sur demande en région genevoise. Pour le reste de la Suisse, nous collaborons avec un réseau d'installateurs partenaires.",
        },
        {
          q: "Quelle est la garantie sur les LED ?",
          a: "Nos modules LED sont garantis 2 ans (pièces). La durée de vie utile des LED professionnelles est de 50'000 heures minimum.",
        },
        {
          q: "Comment commander une enseigne sur-mesure ?",
          a: "Configurez votre enseigne directement sur le site (croix, lettres, caducée…), ajoutez-la au panier puis validez votre commande. Réponse confirmée sous 24h ouvrées.",
        },
        {
          q: "Quels moyens de paiement acceptez-vous ?",
          a: "Virement bancaire, carte bancaire (via Stripe pour paiement en ligne sécurisé), facture pour professionnels suisses avec TVA à 8.1%.",
        },
        {
          q: "La TVA suisse est-elle incluse dans vos prix ?",
          a: "Nos prix affichés sont hors taxes (HT). La TVA suisse au taux normal de 8.1% est ajoutée automatiquement sur la facture finale. Signapharma est enregistrée sous le numéro IDE CHE-114.379.827.",
        },
        {
          q: "Faut-il une autorisation communale pour installer une croix de pharmacie ?",
          a: "Oui, la plupart des communes suisses exigent une autorisation de réclame lumineuse avant installation (Genève, Lausanne, Sion, Neuchâtel, Fribourg, etc.). Nous fournissons les plans techniques et photomontages nécessaires au dossier de demande.",
        },
        {
          q: "Vos enseignes respectent-elles les normes suisses de luminance nocturne ?",
          a: "Absolument. Nos croix LED sont équipées d'un capteur crépusculaire et d'un variateur automatique pour respecter les limites de luminance nocturne imposées par les cantons (typiquement 500 cd/m² max en zone urbaine, ordonnance OPB).",
        },
        {
          q: "Intervenez-vous en Valais et dans le Jura ?",
          a: "Oui. Notre atelier est à Genève mais nous livrons et installons dans toute la Suisse romande : Genève, Vaud (Lausanne), Valais (Sion, Martigny, Sierre), Fribourg, Neuchâtel et Jura. Frais de déplacement transparents devisés à l'avance.",
        },
        {
          q: "Puis-je récupérer et réutiliser un ancien caducée / logo existant ?",
          a: "Oui. Signapharma étudie et intègre vos anciens éléments (caducée, logo, lettres boîtier) dans le nouveau projet quand cela est techniquement viable. Un audit sur site est réalisé au préalable.",
        },
        {
          q: "Le rétroéclairage LED (halo lumineux) consomme-t-il plus qu'un néon classique ?",
          a: "Non, tout au contraire. Une lettre boîtier LED rétroéclairée consomme environ 5-8 W contre 20-40 W pour un néon fluorescent traditionnel, soit 70 à 80% d'économie d'énergie et une durée de vie 3 à 5 fois supérieure.",
        },
      ],
    },
    contact: {
      title: "Contact",
      subtitle:
        "Une question, un projet ? Notre équipe genevoise vous répond sous 24h.",
      name: "Nom et prénom",
      email: "E-mail",
      phone: "Téléphone",
      subject: "Sujet",
      message: "Votre message",
      send: "Envoyer le message",
      success: "Message envoyé. Merci !",
      error: "Une erreur est survenue, merci de réessayer.",
      address_label: "Adresse",
      address_value: "Signapharma — Genève, Suisse",
      phone_label: "Téléphone",
      phone_value: "+41 76 222 36 03",
      email_label: "E-mail",
      email_value: "info@signapharma.ch",
      web_label: "Site",
      web_value: "www.signapharma.ch",
    },
    footer: {
      tagline: "Enseignes lumineuses pour pharmacies. Genève, Suisse.",
      nav_title: "Navigation",
      cat_title: "Catégories",
      contact_title: "Contact",
      rights: "Tous droits réservés.",
    },
    common: {
      menu: "Menu",
      close: "Fermer",
      loading: "Chargement…",
      back: "Retour",
    },
  },

  de: {
    nav: {
      home: "Startseite",
      products: "Produkte",
      gallery: "Galerie",
      faq: "FAQ & Versand",
      contact: "Kontakt",
      cart: "Warenkorb",
      quote: "Angebot anfragen",
    },
    hero: {
      eyebrow: "Genf · Schweiz",
      title_line1: "Leuchtschilder",
      title_line2: "für Apotheken",
      subtitle:
        "Signapharma — Spezialist und Lieferant für Apotheken-Leuchtschilder. Genfer Unternehmen, Versand in die gesamte Schweiz.",
      cta_primary: "Produkte entdecken",
      cta_secondary: "Kontakt aufnehmen",
    },
    categories_section: {
      label: "Katalog",
      title: "Zwei Welten, ein Anspruch",
      subtitle:
        "Von hochsichtbaren Apothekerkreuzen bis zu massgeschneiderten Leuchtbuchstaben.",
    },
    cat: {
      croix: {
        name: "Apothekerkreuz",
        desc: "Klassische, Punkt-zu-Punkt und Neon-LED-Kreuze.",
      },
      enseigne: {
        name: "Apotheken-Schilder",
        desc: "Gehäusebuchstaben, rückseitig beleuchtet, Edelstahl, Neon.",
      },
    },
    home_features: {
      title: "Die Schweizer Leuchtsignatur",
      f1_title: "Massanfertigung",
      f1_desc: "Jedes Projekt wird individuell geplant und gefertigt.",
      f2_title: "Lieferung Schweiz",
      f2_desc: "Sorgfältiger Versand in die ganze Schweiz ab Genf.",
      f3_title: "Garantie & Service",
      f3_desc: "Professionelle LED-Komponenten mit Garantie.",
    },
    products: {
      title: "Unsere Produkte",
      subtitle: "Entdecken Sie die beiden Signapharma-Linien.",
      view: "Produkt ansehen",
      from: "Auf Anfrage",
      filter: "Filter",
      all: "Alle",
      subcategories: "Unterkategorien",
    },
    pdp: {
      configure: "Konfigurieren Sie Ihr Schild",
      dimensions: "Masse",
      finish: "Oberfläche",
      lighting: "Beleuchtung",
      color: "Farbe",
      add_to_cart: "In den Warenkorb",
      ask_quote: "Angebot anfragen",
      description: "Beschreibung",
      features: "Eigenschaften",
      delivery: "Fertigung & Lieferung 3 bis 5 Wochen · Schweiz",
      related: "Ähnliche Produkte",
      your_text: "Ihr Text",
      font: "Schriftart",
      backing: "Trägerform",
      preview_label: "Live-Vorschau",
    },
    cart: {
      title: "Ihr Warenkorb",
      empty: "Ihr Warenkorb ist leer.",
      continue: "Weiter einkaufen",
      checkout: "Zur Kasse",
      item: "Artikel",
      qty: "Menge",
      remove: "Entfernen",
      summary: "Zusammenfassung",
      note: "Endpreise nach Prüfung der Konfiguration.",
      total_items: "Artikel insgesamt",
    },
    checkout: {
      title: "Anfrage abschliessen",
      subtitle:
        "Senden Sie uns Ihre Kontaktdaten — Antwort innerhalb von 24 Std.",
      name: "Vor- und Nachname",
      email: "E-Mail",
      phone: "Telefon",
      company: "Apotheke / Firma",
      address: "Adresse",
      city: "Stadt",
      postal_code: "PLZ",
      country: "Land",
      notes: "Bemerkungen",
      submit: "Anfrage senden",
      success: "Anfrage gesendet — wir melden uns umgehend.",
      error: "Ein Fehler ist aufgetreten.",
    },
    gallery: {
      title: "Referenzen",
      subtitle: "Einige in der Schweiz installierte Signapharma-Schilder.",
    },
    faq: {
      title: "FAQ & Versand",
      subtitle: "Alles, was Sie für Ihre Bestellung wissen müssen.",
      items: [
        {
          q: "Liefern Sie in die gesamte Schweiz?",
          a: "Ja, wir versenden ab Genf in alle Kantone. Versandkosten je nach Volumen und Zielort.",
        },
        {
          q: "Fertigungszeiten?",
          a: "3 bis 5 Wochen je nach Komplexität und Oberfläche.",
        },
        {
          q: "Bieten Sie Montage an?",
          a: "Ja, in der Region Genf. Schweizweit über unser Partnernetz.",
        },
        {
          q: "LED-Garantie?",
          a: "2 Jahre Garantie auf LED-Module, Lebensdauer min. 50'000 Stunden.",
        },
        {
          q: "Individuelles Angebot?",
          a: "Ja, konfigurieren Sie Ihr Schild und fordern Sie ein Angebot an.",
        },
        {
          q: "Zahlungsarten?",
          a: "Banküberweisung, Kreditkarte (bald online), Rechnung für Schweizer Firmen.",
        },
      ],
    },
    contact: {
      title: "Kontakt",
      subtitle: "Frage oder Projekt? Wir antworten innerhalb von 24 Std.",
      name: "Vor- und Nachname",
      email: "E-Mail",
      phone: "Telefon",
      subject: "Betreff",
      message: "Ihre Nachricht",
      send: "Nachricht senden",
      success: "Nachricht gesendet. Danke!",
      error: "Ein Fehler ist aufgetreten.",
      address_label: "Adresse",
      address_value: "Signapharma — Genf, Schweiz",
      phone_label: "Telefon",
      phone_value: "+41 76 222 36 03",
      email_label: "E-Mail",
      email_value: "info@signapharma.ch",
      web_label: "Web",
      web_value: "www.signapharma.ch",
    },
    footer: {
      tagline: "Leuchtschilder für Apotheken. Genf, Schweiz.",
      nav_title: "Navigation",
      cat_title: "Kategorien",
      contact_title: "Kontakt",
      rights: "Alle Rechte vorbehalten.",
    },
    common: {
      menu: "Menü",
      close: "Schliessen",
      loading: "Laden…",
      back: "Zurück",
    },
  },

  en: {
    nav: {
      home: "Home",
      products: "Products",
      gallery: "Gallery",
      faq: "FAQ & Shipping",
      contact: "Contact",
      cart: "Cart",
      quote: "Request a quote",
    },
    hero: {
      eyebrow: "Geneva · Switzerland",
      title_line1: "Luminous signs",
      title_line2: "for pharmacies",
      subtitle:
        "Signapharma, specialist and supplier of luminous signs for pharmacies. Geneva-based, shipping across Switzerland.",
      cta_primary: "Explore our products",
      cta_secondary: "Contact us",
    },
    categories_section: {
      label: "Catalog",
      title: "Two worlds, one standard",
      subtitle:
        "From high-visibility pharmacy crosses to custom lettered signs, we light up your pharmacy.",
    },
    cat: {
      croix: {
        name: "Pharmacy Crosses",
        desc: "Classic, dot-matrix and LED neon crosses.",
      },
      enseigne: {
        name: "Pharmacy Signs",
        desc: "Box letters, backlit, stainless steel and indoor neon.",
      },
    },
    home_features: {
      title: "The Swiss luminous signature",
      f1_title: "Custom manufacturing",
      f1_desc: "Every project is designed and manufactured to your needs.",
      f2_title: "Swiss delivery",
      f2_desc: "Careful shipping across Switzerland from Geneva.",
      f3_title: "Warranty & support",
      f3_desc: "Professional-grade LED components, warrantied.",
    },
    products: {
      title: "Our products",
      subtitle: "Explore both Signapharma ranges.",
      view: "View product",
      from: "On quote",
      filter: "Filter",
      all: "All",
      subcategories: "Subcategories",
    },
    pdp: {
      configure: "Configure your sign",
      dimensions: "Dimensions",
      finish: "Finish",
      lighting: "Lighting",
      color: "Color",
      add_to_cart: "Add to cart",
      ask_quote: "Request a quote",
      description: "Description",
      features: "Features",
      delivery: "Manufacturing & delivery 3–5 weeks · Switzerland",
      related: "Related products",
      your_text: "Your text",
      font: "Font",
      backing: "Backing / shape",
      preview_label: "Live preview",
    },
    cart: {
      title: "Your cart",
      empty: "Your cart is empty.",
      continue: "Continue shopping",
      checkout: "Checkout",
      item: "Item",
      qty: "Qty",
      remove: "Remove",
      summary: "Summary",
      note: "Final pricing is shared after we review your configuration.",
      total_items: "Total items",
    },
    checkout: {
      title: "Complete my request",
      subtitle: "Send us your details — we reply within 24h.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      company: "Pharmacy / Company",
      address: "Address",
      city: "City",
      postal_code: "Postal code",
      country: "Country",
      notes: "Notes",
      submit: "Send request",
      success: "Request sent — we'll get back to you shortly.",
      error: "Something went wrong, please try again.",
    },
    gallery: {
      title: "Gallery",
      subtitle: "Some Signapharma signs installed across Switzerland.",
    },
    faq: {
      title: "FAQ & Shipping",
      subtitle: "Everything you need to know to order your sign.",
      items: [
        {
          q: "Do you ship across Switzerland?",
          a: "Yes. We ship from Geneva to all cantons. Shipping fees may apply based on size and destination.",
        },
        {
          q: "Manufacturing lead times?",
          a: "Custom signs are built in 3 to 5 weeks depending on complexity and finishes.",
        },
        {
          q: "Do you offer installation?",
          a: "Yes in the Geneva region. Elsewhere in Switzerland, via our partner network.",
        },
        {
          q: "LED warranty?",
          a: "2-year warranty on LED modules, useful life 50,000+ hours.",
        },
        {
          q: "Custom quote?",
          a: "Absolutely. Configure your product and request a quote — reply within 24h.",
        },
        {
          q: "Payment methods?",
          a: "Bank transfer, credit card (online payment coming soon), invoice for Swiss companies.",
        },
      ],
    },
    contact: {
      title: "Contact",
      subtitle: "Question or project? Our Geneva team replies within 24h.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      subject: "Subject",
      message: "Your message",
      send: "Send message",
      success: "Message sent. Thank you!",
      error: "Something went wrong, please try again.",
      address_label: "Address",
      address_value: "Signapharma — Geneva, Switzerland",
      phone_label: "Phone",
      phone_value: "+41 76 222 36 03",
      email_label: "Email",
      email_value: "info@signapharma.ch",
      web_label: "Website",
      web_value: "www.signapharma.ch",
    },
    footer: {
      tagline: "Luminous signs for pharmacies. Geneva, Switzerland.",
      nav_title: "Navigation",
      cat_title: "Categories",
      contact_title: "Contact",
      rights: "All rights reserved.",
    },
    common: {
      menu: "Menu",
      close: "Close",
      loading: "Loading…",
      back: "Back",
    },
  },

  it: {
    nav: {
      home: "Home",
      products: "Prodotti",
      gallery: "Galleria",
      faq: "FAQ & Spedizione",
      contact: "Contatto",
      cart: "Carrello",
      quote: "Richiedi preventivo",
    },
    hero: {
      eyebrow: "Ginevra · Svizzera",
      title_line1: "Insegne luminose",
      title_line2: "per farmacie",
      subtitle:
        "Signapharma, specialista e fornitore di insegne luminose per farmacie. Società ginevrina, spedizione in tutta la Svizzera.",
      cta_primary: "Scopri i prodotti",
      cta_secondary: "Contattaci",
    },
    categories_section: {
      label: "Catalogo",
      title: "Due universi, un'unica esigenza",
      subtitle:
        "Dalle croci di farmacia ad alta visibilità alle insegne lettera su misura.",
    },
    cat: {
      croix: {
        name: "Croci di farmacia",
        desc: "Croci classiche, punto a punto e neon LED.",
      },
      enseigne: {
        name: "Insegne di farmacia",
        desc: "Lettere scatolate, retroilluminate, inox e neon interno.",
      },
    },
    home_features: {
      title: "La firma luminosa svizzera",
      f1_title: "Fabbricazione su misura",
      f1_desc: "Ogni progetto è studiato e realizzato secondo le vostre esigenze.",
      f2_title: "Consegna Svizzera",
      f2_desc: "Spedizione accurata in tutta la Svizzera da Ginevra.",
      f3_title: "Garanzia & Assistenza",
      f3_desc: "Componenti LED professionali garantiti.",
    },
    products: {
      title: "I nostri prodotti",
      subtitle: "Esplora le due gamme Signapharma.",
      view: "Vedi prodotto",
      from: "Su preventivo",
      filter: "Filtra",
      all: "Tutti",
      subcategories: "Sottocategorie",
    },
    pdp: {
      configure: "Configura la tua insegna",
      dimensions: "Dimensioni",
      finish: "Finitura",
      lighting: "Illuminazione",
      color: "Colore",
      add_to_cart: "Aggiungi al carrello",
      ask_quote: "Richiedi preventivo",
      description: "Descrizione",
      features: "Caratteristiche",
      delivery: "Fabbricazione & consegna 3-5 settimane · Svizzera",
      related: "Prodotti correlati",
      your_text: "Il tuo testo",
      font: "Carattere",
      backing: "Supporto / forma",
      preview_label: "Anteprima in tempo reale",
    },
    cart: {
      title: "Il tuo carrello",
      empty: "Il carrello è vuoto.",
      continue: "Continua gli acquisti",
      checkout: "Procedi all'ordine",
      item: "Articolo",
      qty: "Q.tà",
      remove: "Rimuovi",
      summary: "Riepilogo",
      note: "I prezzi finali saranno comunicati dopo lo studio della configurazione.",
      total_items: "Articoli totali",
    },
    checkout: {
      title: "Completa la richiesta",
      subtitle: "Inviaci i tuoi dati — risposta entro 24h.",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono",
      company: "Farmacia / Azienda",
      address: "Indirizzo",
      city: "Città",
      postal_code: "CAP",
      country: "Paese",
      notes: "Note",
      submit: "Invia richiesta",
      success: "Richiesta inviata — ti ricontattiamo presto.",
      error: "Si è verificato un errore, riprova.",
    },
    gallery: {
      title: "Galleria",
      subtitle: "Alcune insegne Signapharma installate in Svizzera.",
    },
    faq: {
      title: "FAQ & Spedizione",
      subtitle: "Tutto ciò che devi sapere per ordinare la tua insegna.",
      items: [
        {
          q: "Consegnate in tutta la Svizzera?",
          a: "Sì. Spediamo da Ginevra in tutti i cantoni.",
        },
        {
          q: "Tempi di fabbricazione?",
          a: "3-5 settimane in base a complessità e finiture.",
        },
        {
          q: "Offrite l'installazione?",
          a: "Sì, nella regione di Ginevra. Nel resto della Svizzera tramite partner.",
        },
        {
          q: "Garanzia LED?",
          a: "Garanzia 2 anni, durata utile 50'000 ore.",
        },
        {
          q: "Preventivo personalizzato?",
          a: "Certamente. Configura il prodotto e richiedi un preventivo.",
        },
        {
          q: "Metodi di pagamento?",
          a: "Bonifico, carta (pagamento online in arrivo), fattura per aziende svizzere.",
        },
      ],
    },
    contact: {
      title: "Contatto",
      subtitle: "Domanda o progetto? Rispondiamo entro 24h.",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono",
      subject: "Oggetto",
      message: "Il tuo messaggio",
      send: "Invia messaggio",
      success: "Messaggio inviato. Grazie!",
      error: "Si è verificato un errore, riprova.",
      address_label: "Indirizzo",
      address_value: "Signapharma — Ginevra, Svizzera",
      phone_label: "Telefono",
      phone_value: "+41 76 222 36 03",
      email_label: "Email",
      email_value: "info@signapharma.ch",
      web_label: "Sito",
      web_value: "www.signapharma.ch",
    },
    footer: {
      tagline: "Insegne luminose per farmacie. Ginevra, Svizzera.",
      nav_title: "Navigazione",
      cat_title: "Categorie",
      contact_title: "Contatto",
      rights: "Tutti i diritti riservati.",
    },
    common: {
      menu: "Menu",
      close: "Chiudi",
      loading: "Caricamento…",
      back: "Indietro",
    },
  },
};
